/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelRate = new Class({
    Extends:QuriobotElement,
    template: function(){
        var base =  '<div class="panel--wrapper panel--rating holds--data isLoading" family="{{ key }}" id="{{ eid }}">'+
                    '    <div class="panel--main">'+
                    '        <div class="panel--content">'+
                    '            <div role="listbox" aria-label="{{ title }}" class="panel--options rate--options">'+
                    '                {% options %}'+
                    '            </div>'+
                    '        </div>'+
                    '        <div class="panel--overlay">'+
                    '            <div class="icon--checkWrapper fromRight circle">'+
                    '                <div class="check"></div>'+
                    '            </div>'+
                    '            <button type="button" aria-label="' + this.data.i18n.redo.button.title + '" aria-hidden="true" class="icon--redoWrapper">'+
                    '                <div class="redo"></div>'+
                    '            </button>'+
                    '        </div>'+
                    '    </div>'+
                    '</div>';

        var option =  '<div role="option" aria-checked="false" aria-label="Value {{ number }}" class="rating--dot" data-index="{{ index }}">'+
                      '  <div class="dot--content">'+
                      '      <span class="star--element frst"></span>'+
                      '      <span class="star--element scnd"></span>'+
                      '      <span class="star--element thrd"></span>'+
                      '  </div>'+
                      '</div>';

        return {'base': base, 'option': option };
    },
    attach: function(){
        var Dots = this.element.getElements('div.rating--dot');
        Dots.each(function(oDot){
            if(this.data.meta && this.data.meta.ratingType){
                oDot.addClass('display--' + this.data.meta.ratingType);
            }
            oDot.addEvents({
                click:function(){
                    if(oDot.hasClass('selected--option')){
                        Dots.removeClass('selected--option');
                        Dots.set('aria-checked', false);
                        this.selected = null;
                        return;
                    }
                    var oDotIndex = oDot.get('data-index');
                    this.selected = oDotIndex.toInt() + 1;
                    this.after();
                    Dots.each(function(oD,i){
                        if(i <= oDotIndex){

                            if(i == oDotIndex){
                                var id = this.data.eid + i;

                                oD.set('id', id);
                                this.element.getElements('.panel--options')[0]
                                    .set({
                                        'aria-activedescendant': id,
                                        'aria-disabled': true,
                                    });
                            }

                            setTimeout(function(){
                                oD.addClass('selected--option');
                                oD.set('aria-checked', true);
                            },(i * 100));
                        }
                        if(i > oDotIndex){
                            oD.removeClass('selected--option');
                            oD.set('aria-checked', false);
                        }
                    }.bind(this));
                }.bind(this)
            })
        }.bind(this));
    },
    after: function(){
        var answerData = {
            answer:{
                'render':false,
                'value':this.selected,
                'content':this.selected
            }
        };
        this.element.addClass('isAnswered');
        this.answerCallback(this.data, answerData);

        // Add `aria-hidden="true"` after answering to the question
        this.setAriaHidden('.panel--options', true);

        // Remove `aria-hidden="true"` from redo-button
        this.setAriaHidden('.icon--redoWrapper', false);
    }
});
